import { Injectable } from '@angular/core'
import { ListenConfigService as BaseListenConfigService } from '@engineering11/config-web'
import { CnectListenConfig } from '../config'

@Injectable({ providedIn: 'root' })
export class ListenConfigService extends BaseListenConfigService<CnectListenConfig> {}
